export function getOwnProperty<TVal, TFallback = undefined>(
  o: { [k: PropertyKey]: TVal },
  key: PropertyKey,
  fallback?: TFallback
): TVal | TFallback | undefined {
  return Object.prototype.hasOwnProperty.call(o, key)
    ? o[key]
    : fallback !== undefined
    ? fallback
    : undefined;
}
